import { render, staticRenderFns } from "./EditResponsiblePerson.vue?vue&type=template&id=c370b96e&scoped=true"
import script from "./EditResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./EditResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./EditResponsiblePerson.vue?vue&type=style&index=0&id=c370b96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c370b96e",
  null
  
)

export default component.exports